import { ICellRendererParams } from "ag-grid-enterprise";
import { isNil } from "lodash-es";

export const SpeedStatus = (params: ICellRendererParams) => {
  const speed = params.value;

  const heatStatusCode = params.data.HeatStatusCode;

  if (isNil(speed)) {
    return null;
  }

  if (heatStatusCode === "F") {
    return null;
  }

  const color = speed <= 0 ? "gray" : "green";

  const style = {
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    backgroundColor: color,
    margin: "0 auto",
  };

  return <div style={style}></div>;
};
